import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@cmi/addin-core';
import { filter, map, startWith } from 'rxjs';

@Component({
  selector: 'cmi-settings-layout',
  imports: [RouterOutlet, RouterLink, TranslatePipe],
  templateUrl: './settings-layout.html'
})
export class SettingsLayout {
  private readonly _router = inject(Router);

  protected readonly isMainSettingsPage = toSignal(
    this._router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this._router.url === '/settings'),
      startWith(this._router.url === '/settings')
    ),
    { initialValue: this._router.url === '/settings' }
  );
}
